export const categories = [
    {
        id: "weddingService",
        name: "weddingService",
        title_words: ["Wedding", " Service"],
        images: [   
            {
                id: "cetering",
                title: "Cetering",
                url: process.env.PUBLIC_URL + "/images/catering_img.jpg"
            },
            {
                id: "chori",
                title: "Chori",
                url: process.env.PUBLIC_URL + "/images/chori_img.jpg"
            },
            {
                id: "haldiMehandi",
                title: "Haldi Mehandi",
                url: process.env.PUBLIC_URL + '/HALDI_MEHANDI/3854ef09b418cfd65d0cee854b17f596.jpg'
            },
            {
                id: "kankotriLakhen",
                title: "Kankotri Lakhen",
                url: process.env.PUBLIC_URL + '/KANKOTRI_LAKHEN/WhatsApp Image 2026-03-30 at 8.19.23 PM (1).jpeg'
            },
            {
                id: "laganGeet",
                title: "Lagan Geet",
                url: process.env.PUBLIC_URL + '/images/laganGeet_img.jpg'
            },
            {
                id: "mandap",
                title: "Mandap",
                url: process.env.PUBLIC_URL + '/images/mandap_img.jpg'
            },
            {
                id: "stage",
                title: "Stage",
                url: process.env.PUBLIC_URL + '/images/stage_img.jpg'
            },
            {
                id: "varghodo",
                title: "Varghodo",
                url: process.env.PUBLIC_URL + '/images/verghodo.jpg'
            },
        ]
    },
    {
        id: "eventManager",
        name: "Event Manager",
        title_words: ["Event", " Manager"],
        images: [
            {
                id: "hospitality",
                title: "Hospitality",
                url: process.env.PUBLIC_URL + "/images/hospitality_img.jpg"
            },
            {
                id: "logistics",
                title: "Logistics",
                url: process.env.PUBLIC_URL + "/images/logistics_img.jpg"
            },
            {
                id: "overAllManagement",
                title: "Over All Management",
                url: process.env.PUBLIC_URL + "/images/overAllManagement_img.jpg"
            },
            {
                id: "porter",
                title: "Porter",
                url: process.env.PUBLIC_URL + "/images/porter_img.jpg"
            },
            {
                id: "shadow",
                title: "Shadow",
                url: process.env.PUBLIC_URL + "/images/shadow_img.jpg"
            },
        ]
    },
    {
        id: "SpecialService",
        title_words: ["Special", " Service"],
        images: [
            {
                id: "bridelEntry",
                title: "Bridel Entry",
                url: process.env.PUBLIC_URL + "/images/bridelEntry_img.jpg"
            },
            {
                id: "carDecoration",
                title: "Car Decoretion",
                url: process.env.PUBLIC_URL + '/images/carDecoretion_img.jpg'
            },
            {
                id: "danceChoreographers",
                title: "Dance Choreographers",
                url: process.env.PUBLIC_URL + '/images/wedding_dance_choreography.jpg'
            },
            {
                id: "dholi",
                title: "Dholi",
                url: process.env.PUBLIC_URL + '/images/dholi_img.jpg'
            },
            {
                id: "ghodaGadi",
                title: "Ghoda Gadi",
                url: process.env.PUBLIC_URL + '/images/ghoda_gadi.jpg'
            },
            {
                id: "makeup",
                title: "Makeup",
                url: process.env.PUBLIC_URL + '/images/makeUp_img.jpg'
            },
            {
                id: "mehndiArtist",
                title: "Mehndi Artist",
                url: process.env.PUBLIC_URL + '/images/mehendi.jpg'
            },
            {
                id: "postersAndPrints",
                title: "Posters And Prints",
                url: process.env.PUBLIC_URL + '/images/posters.jpeg'
            },
            {
                id: "screen",
                title: "Screen",
                url: process.env.PUBLIC_URL + '/SCREEN/screen.jpg'
            },
            {
                id: "soundOrDj",
                title: "Sound Or Dj",
                url: process.env.PUBLIC_URL + '/images/Dj_img.jpg'
            },
            {
                id: "specialEffects",
                title: "Special Effects",
                url: process.env.PUBLIC_URL + '/images/special_service.jpg'
            },
        ]
    },
    {
        id: "festivalDecoration",
        name: "FestivalDecoration",
        title_words: ["Festival", " Decoration"],
        images: [
            {
                id: "ganpatiDecoration",
                title: "Ganpati Decoration",
                url: process.env.PUBLIC_URL + "/images/ganpatiDecoration_img.jpg"
            }
        ]
    },
    {
        id: "generalDecoration",
        name: "GeneralDecoration",
        title_words: ["General", " Decoration"],
        images: [
            {
                title: "Ballon Decoration",
                url: process.env.PUBLIC_URL + "/images/ballonDecoration_img.jpg"
            },
            {
                title: "Lighting",
                url: process.env.PUBLIC_URL + "/images/lighting_img.jpg"
            }
        ]
    },
    {
        id: "flowerDecoration",
        name: "FlowerDecoration",
        title_words: ["Flower", " Decoration"],
        images: [
            {
                id: "artificialFlowerDecoration",
                title: "Artificial Flower Decoration",
                url: process.env.PUBLIC_URL + '/images/arti_flower.jpg'
            },
            {
                id: "neturalFlowerDecoration",
                title: "Netural Flower Decoration",
                url: process.env.PUBLIC_URL + '/images/ntr_flower.jpg'
            },
            {
                id: "probsDecoretion",
                title: "Probs Decoretion",
                url: process.env.PUBLIC_URL + '/images/probs_decoration.jpg'
            },
        ]
    },
    {
        id: "corporateEvents",
        name: "Corporate Events",
        title_words: ["CORPORATE", " EVENTS"],
        images: [
            {
                id: "artificialFlowerDecoration",
                title: "Artificial Flower Decoration",
                url: process.env.PUBLIC_URL + '/images/artificialFlower_corporate.jpg'
            },
        ]
    },

]

export const event_images = [
    {
        id: "chori",
        images: [
            process.env.PUBLIC_URL + "/images/bridelEntry_img.jpg",
            process.env.PUBLIC_URL + "/images/IMG-20201204-WA0062.jpg",
            process.env.PUBLIC_URL + "/images/IMG-20201215-WA0018.jpg",
            process.env.PUBLIC_URL + "/images/IMG-20210201-WA0023.jpg",
            process.env.PUBLIC_URL + "/images/IMG-20210201-WA0033.jpg",
            process.env.PUBLIC_URL + "/images/IMG-20210201-WA0036.jpg",
            process.env.PUBLIC_URL + "/images/IMG-20210201-WA0038.jpg",
            process.env.PUBLIC_URL + "/images/IMG_20210220_133106.jpg",
            process.env.PUBLIC_URL + "/images/IMG_20211121_173032.jpg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.16 PM (2).jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.17 PM (1).jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.17 PM.jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.18 PM (1).jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.18 PM (2).jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.18 PM.jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.19 PM.jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.22 PM.jpeg",
            process.env.PUBLIC_URL + "/images/WhatsApp Image 2026-03-30 at 8.27.26 PM (1).jpeg"
        ]
    },
    {
        id: "mandap",
        images: [

            process.env.PUBLIC_URL + "/MANDAP/IMG-20190328-WA0038.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG-20190328-WA0039.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG-20190328-WA0047.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG-20200819-WA0051.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG-20200819-WA0059.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG-20200819-WA0081.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG-20200819-WA0086.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG-20200819-WA0089.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG_20220216_202505.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG_20220415_144529.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG_20220415_144619.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG_20220511_192127.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG_20230605_105818.jpg",
            process.env.PUBLIC_URL + "/MANDAP/IMG_20230605_120146.jpg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2025-01-22 at 8.01.35 PM (1).jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.26.08 PM.jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.26.39 PM (1).jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.26.39 PM.jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.27.14 PM.jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.27.15 PM (1).jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.27.15 PM.jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.37.03 PM (1).jpeg",
            process.env.PUBLIC_URL + "/MANDAP/WhatsApp Image 2026-03-30 at 8.37.04 PM.jpeg",
        ]
    },
    {
        id: "stage",
        images: [
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.20.37 PM (1).jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.23.11 PM.jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.26.08 PM (1).jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.27.23 PM (2).jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.27.26 PM.jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.28.15 PM (1).jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.28.15 PM.jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.28.18 PM (1).jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.28.18 PM.jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.36.23 PM.jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.36.54 PM (1).jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.36.55 PM.jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.36.56 PM (1).jpeg",
            process.env.PUBLIC_URL + "/STAGE/WhatsApp Image 2026-03-30 at 8.36.57 PM.jpeg",
        ]
    }
    ,
    {
        id: "kankotriLakhen",
        images: [
            process.env.PUBLIC_URL + "/KANKOTRI_LAKHEN/WhatsApp Image 2026-03-30 at 8.19.04 PM.jpeg",
            process.env.PUBLIC_URL + "/KANKOTRI_LAKHEN/WhatsApp Image 2026-03-30 at 8.19.23 PM (1).jpeg",
            process.env.PUBLIC_URL + "/KANKOTRI_LAKHEN/WhatsApp Image 2026-03-30 at 8.19.23 PM.jpeg",
            process.env.PUBLIC_URL + "/KANKOTRI_LAKHEN/WhatsApp Image 2026-03-30 at 8.19.24 PM.jpeg",
            process.env.PUBLIC_URL + "/KANKOTRI_LAKHEN/WhatsApp Image 2026-03-30 at 8.27.16 PM (1).jpeg",
            process.env.PUBLIC_URL + "/KANKOTRI_LAKHEN/WhatsApp Image 2026-03-30 at 8.27.16 PM.jpeg",
        ]
    },
    {
        id: "haldiMehandi",
        images: [
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/12c790892235b9452049020e1c7b6cc4.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/20aa347e4729b09960f723d7856c59c0.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/23cc7eab0a02fa4b8caa3b77d63fb0bc.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/2b2cbc660153c11cea45ebc8a1e43027.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/357c95e621c8d15cfb0a620e1192f2aa.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/361a8322d79b22fb405226e1bef9cb8c.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/36d943c9068a8182738b48cd6b2af556.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/3854ef09b418cfd65d0cee854b17f596.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/453994c4cfb06e763f4a56cd1b8530d5.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/4a1357dc6820ace5d28367789cacda79.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/5321a993725037f6b1da662633461d37.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/6570cbfeed9daff40bc8123da66bb16f.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/6c70b885515d5400d1a59dd604ab8474.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/73cca7a48d4e08dbfd1ca885be14690f.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/75335546ec142772ab064da9296eccbe.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/7c296a7c0e68684922629768fc23f166.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/7d9bb71492c0738b592e195d1c2cf74d.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/84402eac94b4156fe46f4dc44325b77e.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/8652542b71d7794f88dfec2b0e1c381d.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/87f9b9c74b698a5126198ceac5c61338.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/89b3b09f91d384a3ef1bef62ebd5d945.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/8b9320603b975105ec90ff8d48852312.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/8c5e4136f6aa3632d2d4e9043d556fe9.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/a360dc53975d4563adab7df301bf59d4.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/a7e1c7f7dbd6321b10614fa68b863870.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/aa13370f07c97274e8e2b7a18c23ed9a.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/b349bfa45da6e71b1126771c5dd3f4f9.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/bbe6a59a70039bc3e70d4b2055226582.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/c5089020a69d7bd8b724cd0de23293c7.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/e8349a5b2eaaa17bec80486df2d91088.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/ef3f16316f27444b013c61ab66a06653.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/images (25).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/images (26).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/images (27).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/IMG_20210610_213004.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/IMG_20211120_163222.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/IMG_20211120_165601.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/Screenshot_2021-03-30-11-20-13-74.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/Screenshot_2021-03-30-11-20-39-57.jpg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.34 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.47 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.51 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.51 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.58 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.58 PM (2).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.58 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.59 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.01.59 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.00 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.00 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.01 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.02 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.02 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.03 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.03 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.04 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.04 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2026-03-30 at 8.20.37 PM (1).jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2026-03-30 at 8.20.37 PM.jpeg",
            process.env.PUBLIC_URL + "/HALDI_MEHANDI/WhatsApp Image 2025-01-22 at 8.02.05 PM.jpeg",

        ]
    },
    {
        id: "soundOrDj",
        images: [
            process.env.PUBLIC_URL + "/SOUND_OR_DJ/IMG-20181207-WA0035.jpg",
            process.env.PUBLIC_URL + "/SOUND_OR_DJ/IMG_20211024_101241.jpg",
            process.env.PUBLIC_URL + "/SOUND_OR_DJ/WhatsApp Image 2026-03-30 at 8.26.00 PM.jpeg",
            process.env.PUBLIC_URL + "/SOUND_OR_DJ/WhatsApp Image 2026-03-30 at 8.27.19 PM (1).jpeg",
            process.env.PUBLIC_URL + "/SOUND_OR_DJ/WhatsApp Image 2026-03-30 at 8.28.17 PM (1).jpeg",
            process.env.PUBLIC_URL + "/SOUND_OR_DJ/WhatsApp Image 2026-03-30 at 8.28.17 PM.jpeg",
            process.env.PUBLIC_URL + "/SOUND_OR_DJ/WhatsApp Image 2026-03-30 at 8.36.58 PM (1).jpeg",

        ]
    },
    {
        id: "screen",
        images: [
            process.env.PUBLIC_URL + "/SCREEN/WhatsApp Image 2026-03-30 at 8.22.46 PM (2).jpeg",
            process.env.PUBLIC_URL + "/SCREEN/WhatsApp Image 2026-03-30 at 8.22.47 PM (1).jpeg",
            process.env.PUBLIC_URL + "/SCREEN/WhatsApp Image 2026-03-30 at 8.22.47 PM.jpeg",
            process.env.PUBLIC_URL + "/SCREEN/WhatsApp Image 2026-03-30 at 8.27.21 PM (1).jpeg",
            process.env.PUBLIC_URL + "/SCREEN/WhatsApp Image 2026-03-30 at 8.27.21 PM.jpeg"
        ]
    },
    {
        id: "carDecoration",
        images: [
            process.env.PUBLIC_URL + "/CAR_DECORATION/IMG-20211114-WA0010.jpg",
            process.env.PUBLIC_URL + "/CAR_DECORATION/IMG-20211114-WA0011.jpg",
            process.env.PUBLIC_URL + "/CAR_DECORATION/IMG-20211114-WA0013.jpg"
        ]
    },
    {
        id: "ganpatiDecoration",
        images: [
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.22.43 PM (1).jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.22.43 PM.jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.22.46 PM (1).jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.22.46 PM.jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.36.25 PM.jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.36.48 PM (1).jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.36.48 PM.jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.36.53 PM.jpeg",
            process.env.PUBLIC_URL + "/GANPATI_DECORATION/WhatsApp Image 2026-03-30 at 8.36.54 PM.jpeg"
        ]
    },
    {
        id: "all",
        images: [
            process.env.PUBLIC_URL + "/ALL/WhatsApp Image 2025-03-04 at 4.48.58 PM.jpeg",
            process.env.PUBLIC_URL + "/ALL/IMG_20230531_164613.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20211114-WA0011.jpg",
            process.env.PUBLIC_URL + "/ALL/4c76481cad9dc7793a6609b1288c584d.jpg",
            process.env.PUBLIC_URL + "/ALL/83a40c774a7397cbd1627cc9a98b9a0a.jpg",
            process.env.PUBLIC_URL + "/ALL/cfb75174a8e9174836c1cd2b95e9e784.jpg",
            process.env.PUBLIC_URL + "/ALL/db4d3024d439b87573f14dfe1a536ee.jpg",
            process.env.PUBLIC_URL + "/ALL/e3cc300bbad4fbfe6dc58fe52bfec57e.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20181207-WA0035.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190223-WA0056.jpg",
            process.env.PUBLIC_URL + "/ALL/WhatsApp Image 2025-03-04 at 4.48.59 PM (1).jpeg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0038.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0039.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0040.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0041.jpg",
            process.env.PUBLIC_URL + "/ALL/WhatsApp Image 2025-03-04 at 4.48.59 PM.jpeg",
            process.env.PUBLIC_URL + "/ALL/IMG-20201020-WA0077.jpg",
            process.env.PUBLIC_URL + "/ALL/WhatsApp Image 2025-03-04 at 4.49.00 PM.jpeg",
            process.env.PUBLIC_URL + "/ALL/IMG-20201020-WA0092.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20201020-WA0094.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20201020-WA0095.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20201020-WA0096.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190323-WA0002.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0042.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0043.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0044.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0045.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0046.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0047.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0048.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0049.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190328-WA0050.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0027.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0028.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0030.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0033.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0034.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0035.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0037.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20190625-WA0039.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG20211025204142.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG20211025210435.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG_20230531_173114.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG20241004002243.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG_20211024_101241.jpg",
            process.env.PUBLIC_URL + "/ALL/IMG-20211114-WA0013.jpg",
            process.env.PUBLIC_URL + "/ALL/WhatsApp Image 2025-03-04 at 4.49.00 PM (1).jpeg",
            process.env.PUBLIC_URL + "/ALL/IMG-20211114-WA0010.jpg",
        ]
    }
]
